export enum DistanceTypeEnum {
  MAPA_KM = "Mapa Km",
  VIAGEM_SUPORTE = "Viagem Suporte",
}
